import { Controller } from "@hotwired/stimulus"

// On form submit, swap the submit button to a loading state (spinner + label) so
// the user gets feedback during the server round-trip before a redirect — e.g.
// creating a Stripe Checkout session. Disabling on the submit event is safe: the
// submit is already in flight, so it isn't cancelled.
export default class extends Controller {
  static values = { label: { type: String, default: "Redirecting to checkout…" } }

  submit() {
    const btn = this.element.querySelector('button[type="submit"]')
    if (!btn) return
    btn.disabled = true
    btn.style.opacity = "1"
    btn.innerHTML =
      '<span class="inline-flex items-center justify-center gap-2">' +
      '<span class="h-4 w-4 rounded-full border-2 border-white/40 border-t-white animate-spin"></span>' +
      this.labelValue +
      "</span>"
  }
}
